import { TableHeaderItem } from "@/views/components/YtoTable/TableHeaderItem";

const defaultWidth = 300;

const tableHeader: TableHeaderItem[] = [
  { prop: 'index', label: '序号', width: null, fixed: "left" },
  { prop: 'code', label: '条码', width: null, fixed: "left" },
  { prop: 'ScanTime', label: '扫描时间', width: null },
  { prop: 'Info', label: '提示/警告信息', width: null , fixed: "right"},
];
export default { tableHeader }
